import React, {Fragment} from "react"
import { Link } from "react-router-dom"

const BlogTwoContent = [
    {
        img: "blog-03",
        tag: "Investigación , Tecnología",
        desc: "Google está eliminando la sección de Películas y TV de la Play Store",
        authorName: "Samir Jam",
        date: "21 Jan 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-04",
        tag: "Investigación , Tecnología",
        desc: "Twitter pide a los accionistas aprobar la adquisición de $44 mil millones de Elon Musk",
        authorName: "Anisa Kdar",
        date: "02 Aug 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-05",
        tag: "Investigación , Tecnología",
        desc: "Donde las Mentes se Encuentran con las Máquinas: El Futuro de la Robótica",
        authorName: "Samir Jam",
        date: "21 Jan 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-06",
        tag: "Investigación , Tecnología",
        desc: "Anunciando la agenda completa de TC Sessions: Robótica este julio",
        authorName: "Hamina",
        date: "09 Feb 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-07",
        tag: "Investigación , Tecnología",
        desc: "El pulso en tu mano: la startup API-first Vivanta aspira a ser el Plaid de la salud",
        authorName: "Anisa Kdar",
        date: "17 Sep 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-08",
        tag: "Investigación , Tecnología",
        desc: "Fermyon quiere reinventar la forma en que los programadores desarrollan microservicios",
        authorName: "Samir Jam",
        date: "21 jan 2021",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-09",
        tag: "Investigación , Tecnología",
        desc: 'Los términos de los acuerdos cambian en una recesión. Esto es lo que debes tener en cuenta',
        authorName: "Chris Hams",
        date: "19 Jun 2222",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-10",
        tag: "Investigación , Tecnología",
        desc: "Neuron7 recauda $10M para ayudar a los agentes de servicio al cliente a encontrar soluciones",
        authorName: "Anisa Kdar",
        date: "21 Jan 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-11",
        tag: "Investigación , Tecnología",
        desc: "Kibo School obtiene $2M para ofrecer títulos STEM en línea a estudiantes en África",
        authorName: "Samir jam",
        date: "04 Oct 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }
]

const BlogStyleTwo = () => {
    return (
        <Fragment>
            <div className="row gx-4 gx-xxl-5">
                {BlogTwoContent.map((val, i)=>(
                    <div key={i} className="col-lg-4 col-md-6">
                        <div className="blog-style-two mb-45">
                            <div className="blog-thumb">
                                <img className="w-100" src={`assets/img/blog/${val.img}.jpg`} alt="img"/>
                            </div>
                            <div className="blog-content">
                                <div className="blog-tag pb-10">
                                    {val.tag}
                                </div>
                                <h3>
                                    <Link className="blog-title" to="/blog-details">{val.desc}</Link>
                                </h3>
                                <div className="blog-meta">
                                    <a href="#" className="mr-20"><i className={val.icon1}/>
                                        {val.authorName}</a>
                                    <a href="#"><i className={val.icon2}/>
                                        {val.date}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </Fragment>
    )
}

export default BlogStyleTwo